module.exports = __webpack_public_path__ + "static/media/widget-thumbnail.bfc799af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/screenCaptures/widget-thumbnail.png
// module id = 1438
// module chunks = 0